import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Usuario = {
  id: string;
  email: string;
  nombre: string;
  roles: string[];
};

export type EnteOpcion = {
  id: string;
  clave: string;
  nombre: string;
  rol: string;
};

type AuthState = {
  token: string | null;
  expiraEn: string | null;
  usuario: Usuario | null;
  enteActual: EnteOpcion | null;
  entesOpciones: EnteOpcion[];
  permisos: string[];
  theme: 'light' | 'dark';

  setSession: (p: {
    token: string;
    expira_en: string;
    usuario: Usuario;
    ente_actual: EnteOpcion | null;
    entes_opciones: EnteOpcion[];
  }) => void;
  setMe: (p: { permisos: string[]; entes: EnteOpcion[]; ente_actual_id: string }) => void;
  clear: () => void;
  toggleTheme: () => void;
  hasPerm: (clave: string) => boolean;
};

export const useAuth = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      expiraEn: null,
      usuario: null,
      enteActual: null,
      entesOpciones: [],
      permisos: [],
      theme: 'light',

      setSession: (p) =>
        set({
          token: p.token,
          expiraEn: p.expira_en,
          usuario: p.usuario,
          enteActual: p.ente_actual,
          entesOpciones: p.entes_opciones ?? [],
        }),
      setMe: (p) =>
        set((s) => ({
          permisos: p.permisos,
          entesOpciones: p.entes,
          enteActual: p.entes.find((e) => e.id === p.ente_actual_id) ?? s.enteActual,
        })),
      clear: () =>
        set({
          token: null,
          expiraEn: null,
          usuario: null,
          enteActual: null,
          entesOpciones: [],
          permisos: [],
        }),
      toggleTheme: () => {
        const next = get().theme === 'light' ? 'dark' : 'light';
        document.documentElement.classList.toggle('dark', next === 'dark');
        set({ theme: next });
      },
      hasPerm: (clave) => {
        const s = get();
        return s.usuario?.roles.includes('super_admin') || s.permisos.includes(clave);
      },
    }),
    {
      name: 'scgmex.auth',
      partialize: (s) => ({
        token: s.token,
        expiraEn: s.expiraEn,
        usuario: s.usuario,
        enteActual: s.enteActual,
        entesOpciones: s.entesOpciones,
        permisos: s.permisos,
        theme: s.theme,
      }),
      onRehydrateStorage: () => (state) => {
        if (state?.theme === 'dark') document.documentElement.classList.add('dark');
      },
    }
  )
);
